<template>
    <Head title="Dashboard" />
    <div class="w-screen h-auto py-16 bg-slate-700 text-white">
        <div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
            <ul>
                <li><Link href="/admin/image-editor">Image Editor</Link></li>
                <li v-for="p in pages" :key="p.id">
                    <Link :href="`/admin/admin-page/${p.id}`" class="text-yellow-400">{{ p.all_parents[0]?.slug }} / {{ p.page_title }} ({{ p.id }})</Link>
                    <div class="flex flex-wrap ml-12">
                        <!-- <ul class="w-1/2">
                            <li v-for="c in p.children" :key="c.id">
                                {{ c }}
                            </li>
                        </ul> -->
                        <ul class="w-full">
                            <li v-for="po in p.page_objects" :key="po.id">
                                {{ po.objectable_type }} ({{po.objectable_id }})
                                <!-- <Carousel v-if="po.objectable_type=='App\\Models\\Carousel'" :items="po.objectable?.items" /> -->
                                <!-- <Gallery v-if='po.objectable_type=="App\\Models\\Gallery"' :images="po.objectable?.images" /> -->
                                <!-- <VideoObject v-if="po.objectable_type=='App\\Models\\Video'" :object="po" /> -->
                                <!-- <ParagraphObject v-if="po.objectable_type=='App\\Models\\Paragraph'" :object="po" /> -->
                                <!-- <MultiParagraphObject v-if="po.objectable_type=='App\\Models\\MultiParagraph'" :object="po" /> -->
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>

import Layout from '@/layouts/AuthenticatedLayout.vue';
import { Link, Head } from '@inertiajs/vue3';

export default {
    name: 'AdminDashboard',
    components: { Head, Link },
    layout: Layout,
    props: ['pages']
}
</script>
